import { AnalysisResult } from '../types/health.types';
import { HealthSectionKey } from '../config/healthAnalysisConfig';
import { useHealthAnalysisQuery } from '../services/healthAnalysis.queries';

// STD-015: thin adapter — preserves the { analyses, loading, error }
// return shape expected by HealthPanelTab while delegating fetch to TanStack Query.

export const useHealthAnalysis = (
  droneSerial: string | null,
  sectionKey: HealthSectionKey
): { analyses: AnalysisResult[]; loading: boolean; error: string | null } => {
  const { analyses, isLoading, error } = useHealthAnalysisQuery(droneSerial, sectionKey);
  return { analyses, loading: isLoading, error };
};
